var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvitations = function SvgInvitations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m17.846 6.458-4.756 4.756-1.179-1.178 2.744-2.744H7.917a3.75 3.75 0 0 0 0 7.5H12.5a.834.834 0 1 1 0 1.666H7.917a5.417 5.417 0 1 1 0-10.833h6.738l-2.744-2.744 1.179-1.179z"
  })));
};
export default SvgInvitations;